<div class="screen-lock" [ngClass]="{ lock: isScreenLocked$ | async }"></div>
<mat-progress-bar
  [value]="progress$ | async"
  [ngClass]="(isLoading$ | async) ? 'visible' : 'invisible'"
></mat-progress-bar>
